import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
	timeout: 600000, // 10 minutos (600000ms) - para operações longas como exclusão de empresas
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	timeout: 30000, // 30 segundos para APIs públicas
});

// ✅ Interceptor para ignorar silenciosamente erros 403 em public-settings
openApi.interceptors.response.use(
	(response) => response,
	(error) => {
		// Ignorar silenciosamente erros 403 em public-settings (token não configurado)
		if (error?.response?.status === 403 && error?.config?.url?.includes('/public-settings/')) {
			// ✅ Suprimir o erro do console silenciosamente
			// Retornar uma resposta vazia para não quebrar o código
			return Promise.resolve({ data: null, status: 403 });
		}
		// Para outros erros, rejeitar normalmente
		return Promise.reject(error);
	}
);

// ✅ Interceptor de requisição para suprimir logs de erros 403 esperados
openApi.interceptors.request.use(
	(config) => config,
	(error) => Promise.reject(error)
);

export default api;
